document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#outline-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "outlineEmbroidery"
      );

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
            card.dataset.outline;

          console.log(
            "OUTLINE:",
            hidden.value
          );

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);